import { gql } from "@/__generated__/gql";

export const MY_PROFILE = gql(`
  query MyProfile {
    me {
        id
        uuid
        firstName
        lastName
        bio
        email
        phoneNumber
        locationCity {
            id
            displayString
        }
        interests {
            nodes {
                id
                name
            }
        }
        majors {
            nodes {
                id
                name
            }
        }
        profilePhoto {
            id
            url(size: 200)
        }
        officialOrganization {
            ssoEnabled
        }
    }
}
`);
